import React from "react";
import styled from "styled-components";
import {
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TableHeader,
  TableRow,
} from "../../shadcn/table";

const StyledTable = ({ children, ...props }) => {
  return (
    <TableWrapper {...props}>
      <Table>
        {children}
      </Table>
    </TableWrapper>
  );
};

export default StyledTable;

export { TableBody, TableCell, TableFooter, TableHead, TableHeader, TableRow };

const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  overflow: visible;
  background: white;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  width: 100%;

  table {
    border-collapse: separate;
    border-spacing: 0;
    width: 100%;
  }

  th {
    background: #f9fafb;
    padding: 16px 18px;
    font-weight: 600;
    font-size: 14px;
    color: #374151;
    border-bottom: 1px solid #e5e7eb;

    &:first-child {
      border-top-left-radius: 12px;
    }

    &:last-child {
      border-top-right-radius: 12px;
    }
  }

  tfoot th,
  tfoot td {
    background: #f9fafb;
    border-top: 1px solid #e5e7eb;
    border-bottom: none;

    &:first-child {
      border-bottom-left-radius: 12px;
    }

    &:last-child {
      border-bottom-right-radius: 12px;
    }
  }

  td {
    padding: 6px 18px;
    border-bottom: 1px solid #f3f4f6;
    vertical-align: middle;
  }

  tbody tr:last-child td {
    border-bottom: none;
  }

  tbody tr:hover {
    background: #f9fafb;
  }

  input[type="checkbox"] {
    accent-color: #7069fd;
  }
`;